import React from 'react'
import { useSelector } from 'react-redux'
import VideoThumbnail from '../VideoThumbnail/VideoThumbnail.js'

const Grid = ({ videos: propVideos, setVideos, showDelete }) => {
  const searchQuery = useSelector((state) => state.searchQuery)
  const reduxVideos = useSelector((state) => state.videos)

  const displayedVideos = (searchQuery && reduxVideos && reduxVideos.length > 0) 
    ? reduxVideos 
    : propVideos

  if (!displayedVideos || displayedVideos.length === 0) {
    return (
      <div className="w-full text-center py-20 text-gray-500 font-semibold">
        nothing was found baka!! 
      </div>
    )
  }

  return (
    /* Reduced gap from gap-9 to gap-4 to make individual thumbnails larger */
    <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-3 w-full p-0">
      {displayedVideos.map((video) => (
        <VideoThumbnail
          key={video.id}
          setVideos={setVideos}
          video={video}
          showDelete={showDelete}
        />
      ))}
    </div>
  )
}

export default Grid
